<template>
	<div class="sunblockguide">
		<Loading msg="loading" v-if="!isload" />
		<div class="guide_inner" v-else>
      		<img @click="$parent.routerGo('/skincarekeypoints')"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <div class="inner_up">
                    <h1 class="guide_title">高效防晒指南<span @click="$parent.routerGo('/sunblocksurvey?redo=redo',(actParams = { query: $route.query, pageid: 551 }),{is_access:true,reportEvent_page_id:'551',reportEvent_page_name:'防晒-重填问卷',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'})">重填问卷</span></h1>
                    <ul class="detail_menu">
                        <li class="menu_item" :class="focused_idx == 0 ? 'now' : ''" @click="changeFocusedTab(0);" ref="focused_item_0">特征分析</li>
                        <li class="menu_item" :class="focused_idx == 1 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:552 }),{is_access:true,reportEvent_page_id:552,reportEvent_page_name:'防晒-产品推荐',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'}));changeFocusedTab(1);" ref="focused_item_1">产品推荐</li>
                        <li class="menu_item" :class="focused_idx == 2 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:553 }),{is_access:true,reportEvent_page_id:553,reportEvent_page_name:'防晒-使用建议',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'}));changeFocusedTab(2);" ref="focused_item_2">使用建议</li>
                        <span class="bg_div" :style="'width:' + focused_width + 'px;left:' + focused_left + 'px'"></span>
                    </ul>
                </div>
                <!-- 特征分析 -->
                <div class="inner_down inner_down_first" v-if="focused_idx == 0">
                    <div class="down_title">肌肤敏感性</div>
                    <div class="down_item down_item_sensitivity">
                        <div class="item_sug">
                            <div class="item_sug_title">建议您</div>
                            <div class="item_sug_info"><span v-html="guidedata.desc.sensi">使用<strong>温和</strong>的防晒产品，例如<strong>物理</strong>防晒霜</span> &nbsp;<img src="../assets/images/question_mark_icon.svg" alt="" @click="($parent.trackLog((actParams = { query: $route.query, pageid:554 }),{is_access:true,reportEvent_page_id:554,reportEvent_page_name:'防晒-问号解释',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'}));doubt_layer_show=true;doubt_layer_show_type='sensi'"></div>
                        </div>
                            <div class="item_detail">
                                <ul class="item_detail_left">
                                    <li class="detail_left_li" v-if="!(guidedata.sensi.dqmtype == '')"><strong>[现状]屏障:{{guidedata.sensi.dqmtype}}</strong></li>
                                    <li class="detail_left_li"><strong>敏感自述:{{guidedata.sensi.survey_3qs_desc}}</strong></li>
                                    <li class="detail_left_li"><strong>防晒产品使用:{{guidedata.sensi.survey_9qs_desc}}</strong></li>
                                </ul>
                                <img src="../assets/images/sunblock_sensi_icon.png" class="item_detail_pic" alt="">
                            </div>

                    </div>
                    <div class="down_title">抗晒伤能力</div>
                    <div class="down_item down_item_aging">
                           <div class="item_sug">
                            <div class="item_sug_title">建议您</div>
                            <div class="item_sug_info"><span v-html="guidedata.desc.spf">抗衰老相关基因整体偏弱，建议防晒系数例如<strong>SPF</strong>不低于30</span> &nbsp;<img src="../assets/images/question_mark_icon.svg" alt="" @click="($parent.trackLog((actParams = { query: $route.query, pageid:554 }),{is_access:true,reportEvent_page_id:554,reportEvent_page_name:'防晒-问号解释',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'}));doubt_layer_show=true;doubt_layer_show_type='spf'"></div>
                        </div>
                            <div class="item_detail">
                                <ul class="item_detail_left">
                                   <li class="detail_left_li"><strong>自述晒伤风险:{{guidedata.spf.sunburn == 1 ? '较低' : guidedata.spf.sunburn == 2 ? '中等' : '较高'}}</strong></li>
                                    <li class="detail_left_li"><strong>[基因]胶原蛋白:{{guidedata.spf.type20_ch}}</strong></li>
                                    <li class="detail_left_li"><strong>[基因]眼部细纹:{{guidedata.spf.type29_ch}}</strong></li>
                                    <li class="detail_left_li"><strong>[基因]抗氧化能力:{{guidedata.spf.type22_ch}}</strong></li>
                                   
                                </ul>
                                 <img src="../assets/images/sunblock_spf_icon.png" class="item_detail_pic" alt="">
                               <!-- <div class="item_detail_right">
                                 <div class="detail_right_title">SPF</div>
                                 <div class="detail_right_tip">不低于30</div>
                               </div> -->
                            </div>
                    </div>
                    <div class="down_title">抗晒黑能力</div>
                    <div class="down_item down_item_pm">
                           <div class="item_sug">
                            <div class="item_sug_title">建议您</div>
                            <div class="item_sug_info"><span v-html="guidedata.desc.pa">抗晒黑相关基因整体中等，建议防晒系数<strong>PA</strong>不低于++</span> &nbsp;<img src="../assets/images/question_mark_icon.svg" alt="" @click="($parent.trackLog((actParams = { query: $route.query, pageid:554 }),{is_access:true,reportEvent_page_id:554,reportEvent_page_name:'防晒-问号解释',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'}));doubt_layer_show=true;doubt_layer_show_type='pa'"></div>
                        </div>
                            <div class="item_detail">
                                <ul class="item_detail_left">
                                   <li class="detail_left_li"><strong>自述晒黑风险:{{guidedata.pa.survey_tan == 1 ? '较低' : guidedata.pa.survey_tan == 2 ? '中等' : '较高'}}</strong></li>
                                    <li class="detail_left_li"><strong>[基因]抗痘印色斑:{{guidedata.pa.type5_ch}}</strong></li>
                                    <li class="detail_left_li"><strong>[基因]黑色素合成:{{guidedata.pa.type3_ch}}</strong></li>
                                   
                                </ul>
                                 <img src="../assets/images/sunblock_pa_icon.png" class="item_detail_pic" alt="">
                                  <!-- <div class="item_detail_right">
                                    <div class="detail_right_title">PA</div>
                                    <div class="detail_right_tip">不低于30</div>
                                  </div> -->
                            </div>
                    </div>

                </div>

                <!-- 产品推荐 -->
                <div class="inner_down inner_down_second" v-if="focused_idx ==1">

                  <!-- 20191114新增解释及弹窗 -->
                  <div class="sunblock_sub_result_part">
                    <span class="sunblock_sub_result_show_text" @click="show_sunblock_toaster=true">推荐说明</span>
                    <div class="sunblock_sub_result_title">根据你的皮肤特征,为你推荐</div>
                    <div class="sunblock_sub_result_text">
                      <strong>{{sunblock_sensi_text+(sunblock_sensi_text.length > 0 ? '、' : '')+sunblock_harm_text+(sunblock_harm_text.length > 0 ? '、' : '')+sunblock_black_text}}</strong>
                    </div>
                    <div class="sunblock_sub_result_text"><strong>的防晒产品</strong></div>
                    
                  </div>
                <transition name="fade">
                  <div class="sunblock_toaster" v-show="show_sunblock_toaster">
                    <div class="sunblock_toaster_inner">
                      <img src="../assets/images/close_btn.svg" class="sunblock_inner_close_btn" @click="show_sunblock_toaster=false" alt="">
                      <div class="sunblock_toaster_inner_title"><strong>推荐说明</strong></div>
                      <div class="sunblock_toaster_inner_2nd_title">标有“推荐”字样的防晒产品</div>
                      <p class="sunblock_toaster_inner_text">与你的匹配度较高，建议优先在这部分产品中选择你的防晒。匹配依据是你的肌肤敏感性、抗晒伤能力、抗晒黑能力</p>
                      <div class="sunblock_toaster_inner_2nd_title">无“推荐”字样的防晒产品</div>
                      <p class="sunblock_toaster_inner_text">与你的匹配度较低，不建议优先选择。但是你可以根据自己的敏感程度、防晒需求程度和使用历史，自主选择合适的产品</p>
                    </div>
                  </div>
                </transition>

                  <div class="down_title">防晒产品列表</div>
                  <ul class="filter_menu" @click="($parent.trackLog((actParams = { query: $route.query, pageid:555 }),{is_access:true,reportEvent_page_id:555,reportEvent_page_name:'防晒-产品推荐-筛选',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'防晒'}));">
                    <li class="menu_item" :class="recommend == 1 ? 'now' : ''" @click="(recommend == 1 ? recommend = 0 : recommend =1),initProList()">只看推荐</li>
                    <li class="menu_item" :class="is_greasy == 1 ? 'now' : ''" @click="(is_greasy == 1 ? is_greasy = 0 : is_greasy =1),initProList()">不油腻</li>
                    <li class="menu_item" :class="water_proof == 1 ? 'now' : ''" @click="(water_proof == 1 ? water_proof = 0 : water_proof =1),initProList()">防水</li>

                  </ul>
                  <!-- <div class="filter_sub_btn"><span @click="initProList()">筛选</span></div> -->
                  <ul class="filter_pro_list">
                    <li class="filter_pro" :class="pro.recommend == 1 || recommend == 1 ? 'now' : ''" v-for="(pro,pro_idx) in rec_pro_data" :key="pro_idx">
                      <img :src="pro.img_url" class="filter_pro_pic" alt="">
                      <div class="filter_pro_info">
                        <div class="pro_name">{{pro.name}}</div>
                        <div class="pro_price">参考价格:&yen;{{pro.price}}</div>
                        <div class="pro_spf">防晒系数:{{'SPF'+pro.spf+',PA'+(pro.pa == 4 ?'++++':pro.pa == 3 ? '+++' : pro.pa == 2 ? '++' : '')}}</div>
                        <!-- <ul class="pro_tags"><li class="tag">肤感偏油</li></ul>   算法中肤感偏油，偏干已去掉-->
                      </div>
                    </li>
           
                  </ul>

                </div>

                <!-- 使用建议 -->
                <div class="inner_down inner_down_third" v-if="focused_idx == 2">
                    <div class="down_title">防晒该怎么用?</div>
                    <div class="sun_block_sug_2nd_text">外出前10分钟使用防晒有利于防晒在脸上成膜，每次涂抹脸部需要使用约一枚硬币大小的防晒霜，以四指推开的手法均匀涂抹全脸。其他裸露部位如脖子、耳后等记着也要涂抹防晒。</div>
                    <img src="../assets/images/sunblock_guide_poster.png" class="sun_block_2nd_example_pic" alt="">
                    <div class="sun_block_sug_2nd_title">什么时候补涂防晒？</div>
                    <ul class="sun_block_sug_list">
                      <li class="sun_block_sug_info"><span>室内工作者</span><span>一般室内8小时内防晒流失不多，不需要补涂</span></li>
                      <li class="sun_block_sug_info"><span>室外活动</span><span>长期暴露在强烈紫外线下是需要后续补涂防晒的，同样游泳之后或者大量出汗之后也需要补涂防晒霜，每两个小时补涂一次防晒霜是非常有必要的</span></li>
                     
                    </ul>
                    <div class="sun_block_sug_2nd_title">不同场合的防晒霜</div>
                    <ul class="sun_block_sug_list sun_block_sug_list_2">
                      <li class="sun_block_sug_info"><span>室内工作者</span><span>SPF 15，PA+</span></li>
                      <li class="sun_block_sug_info"><span>一般户外活动工作者</span><span>SPF 30，PA+++</span></li>
                      <li class="sun_block_sug_info"><span>特殊户外活动，如雪山、海滩、高原等强UV环境</span><span>SPF50，PA++++</span></li>
                      <li class="sun_block_sug_info"><span>沙滩运动、游泳</span><span>SPF50，PA++++，防水型</span></li>
                    </ul>
                    <div class="sun_block_sug_2nd_title">用了防晒还要卸妆吗？</div>
                    <div class="sun_block_sug_2nd_title_name">无防水功能的防晒霜</div>
                    <p class="sun_block_sug_2nd_title_desc">可以直接使用普通洁面产品清洁即可，不需要先卸妆后洁面。</p>
                    <div class="sun_block_sug_2nd_title_name">防水型防晒霜</div>
                     <p class="sun_block_sug_2nd_title_desc">先使用卸妆产品将防晒霜卸干净，然后再使用洁面产品进行后续清洁。</p>
                </div>

		
		</div>

    <!-- 防晒问好解释弹窗 -->
    <transition name="fade">
    <div class="sunblock_doubt_layer" v-show="doubt_layer_show">
      <div class="sunblock_layer_card">
        <span class="sunblock_doubt_layer_title">{{doubt_layer_info[doubt_layer_show_type].title}}</span>
        <p class="sunblock_doubt_text" v-html="doubt_layer_info[doubt_layer_show_type].text"></p>
        
        <img src="../assets/images/close_btn.png" class="sunblock_doubt_close" alt="" @click="doubt_layer_show=false;">
      </div>
    </div>
    </transition>


 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
import { setTimeout } from 'timers';
var wx = require("weixin-js-sdk");
export default {
  name: "SunBlockGuide",
  data() {
    return {
      isload: false,
      focused_idx:0,
      focused_left:0,
      focused_width:0,
      triangle_left:30,  //成分详情icon
      in_weapp: false, //是否在小程序
      show_sunblock_toaster:false,   //展示解释弹窗
      sunblock_harm_text:"",  //抗晒伤文案
      sunblock_black_text:"",  //抗晒黑文案
      sunblock_sensi_text:"",  //肌肤敏感性文案
      guidedata:null,
      show_rec:true,  //早晚护肤列表
      show_oth:false,  //对应类型产品
      filter_idx:0,   //防晒产品推荐 菜单
      rec_pro_data:null,  //防晒护肤推荐列表
      water_proof:0,  //产品筛选 防水 0 1
      is_greasy:0,   //产品筛选 油腻 
      recommend:0,   //产品筛选 推荐
      doubt_layer_show:false, //防晒疑问弹窗
      doubt_layer_show_type:"sensi",  //防晒疑问弹窗对应 sensi spf pa
      doubt_layer_info:{
        sensi:{
          title:"防晒剂",
          text:"物理防晒剂：即氧化锌和二氧化钛。这种防晒剂比较温和，通过反射、散射紫外线来达到防晒效果。敏感性皮肤最好选择纯物理防晒霜。<br>化学防晒剂：绝大多数防晒剂属于这个类别，防晒原理是吸收紫外线。化学防晒剂的温和性不如物理防晒剂，但化学防晒产品使用感较好，且物化结合可以有更广谱的防晒能力。"
        },
        spf:{
          title:"SPF",
          text:"SPF值代表对UVB的防护效果，能够防止皮肤晒伤。SPF值越高，对UVB的防护效果越好。"
        },
        pa:{
          title:"PA",
          text:"PA值代表对UVA的防护效果，能够防止皮肤晒黑。PA后面“+”的数目越多，对UVA的防护效果越好。PA值在日系防晒中被广泛应用。"
        }
      },

    };
  },

  created() {
    console.log("skincareguide created", this);
    this.initSunBlockGuide();
  },
  mounted() {
        setTimeout(() => {
			this.changeFocusedTab(this.focused_idx);
		}, 500);
      
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
      getTriangleLeft:function(index){
          console.log(this.$refs);
          this.triangle_left = this.$refs['ing_'+index].offsetLeft - this.$refs['ing_box'].scrollLeft -10;
        // this.triangle_left = this.$refs['ing_box'].scrollLeft;
        if(this.triangle_left < 30){
            this.triangle_left = 30;
        }
      },
    changeFocusedTab: function(idx) {
			this.focused_idx = idx;
			console.log(271, this.$refs['focused_item_' + idx]);
			this.focused_width = this.$refs['focused_item_' + idx].clientWidth;
			this.focused_left = this.$refs['focused_item_' + idx].offsetLeft;
      console.log(this.focused_width,this.focused_left);
		},
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initSunBlockGuide: function() {
      let that = this;
      var local_sun_block_guide = JSON.parse(localStorage.getItem("local_sun_block_guide"));
      if (local_sun_block_guide) {
        afterSunBlockGuide(local_sun_block_guide);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getAnsResult"
          )
          .then(json => {
            console.log('sunblockguide',json);
            afterSunBlockGuide(json);
            // localStorage.setItem("local_sun_block_guide",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterSunBlockGuide(guidedata) {
        if (guidedata.code == 0) {
          that.isload = true;
        //20191109 添加防晒弹窗及内容解释
        let gene_aging = guidedata.data.spf.aging;
        let gene_black = guidedata.data.pa.gene_tan;
        let sensi_level  = guidedata.data.sensi.level;
        let sun_burn = guidedata.data.spf.sunburn;
        let survey_tan = guidedata.data.pa.survey_tan;
        // sunblock_harm_text:"";
        // sunblock_black_text:"";
        // sunblock_sensi_text:"";
        if(sensi_level == 1){
          that.sunblock_sensi_text = "";
        }else if(sensi_level == 2){
          that.sunblock_sensi_text = "成分较温和";
        }else{
           that.sunblock_sensi_text = "纯物理防晒剂";
        }

        if(sun_burn == 3){
          that.sunblock_harm_text = "SPF不低于30";
        }else if (sun_burn == 2){
          if(gene_aging == 3){
            that.sunblock_harm_text = "SPF不低于20";
          }else{
            that.sunblock_harm_text = "SPF不低于30";
          }
        }else{
          if(gene_aging == 3){
            that.sunblock_harm_text = "";
          }else{
            that.sunblock_harm_text = "SPF不低于20";
          }
        }

        if(survey_tan == 3){
          that.sunblock_black_text = "PA+++或更高";
        }else if (survey_tan == 2){
          if(gene_black == 3){
            that.sunblock_black_text = "PA++或更高";
          }else{
            that.sunblock_black_text = "PA+++或更高";
          }
        }else{
          if(gene_black == 3){
            that.sunblock_black_text = "";
          }else{
            that.sunblock_black_text = "PA++或更高";
          }
        }



          //对应屏障描述
          if(guidedata.data.sensi.dqmtype == "很好"){
            guidedata.data.sensi.dqmtype = "完好";
          }else if(guidedata.data.sensi.dqmtype == "一般"){
            guidedata.data.sensi.dqmtype = "轻微损伤";
          }else if(guidedata.data.sensi.dqmtype == "较差"){
            guidedata.data.sensi.dqmtype = "损伤";
          }
          that.guidedata = guidedata.data;
          return that.initProList();

        }
      }
    },
    initProList:function(){  //获取防晒蟾皮列表
    let that = this;
    console.log(that.recommend,that.is_greasy,that.water_proof);
    that.$jsonp("https://www.uniskin.com.cn/reportv2/index/report199_ex1/getSunProofGoods",{water_proof:that.water_proof,is_greasy:that.is_greasy,recommend:that.recommend})
    .then( json => {
      console.log("推荐",json);
      if(json.code == 0){
        that.rec_pro_data = json.data;
        console.log('prolist',json);
      }else if(json.code == 100){
        alert("请先登录");
         location.href = "https://www.uniskin.com.cn/mall/member/account/login";
      }else{
        alert(json.msg);
      }
    })
    .catch( err => {
      console.log(err);
          // location.href = "https://www.uniskin.com.cn/mall/member/account/login";
    })

    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
//20191114 新增防晒弹窗及解释
.sunblock_sub_result_part{
  margin-bottom:54/50rem;
  position:relative;
  .shadow;
  .border-radius(14/50rem);
  padding:34/50rem 30/50rem 65/50rem;
  background:#fcfcfc;
  .sunblock_sub_result_title{
    font-size:24/50rem;
    line-height:1em;
    color:@font-c-3;
    padding-bottom:50/50rem;
  }
  .sunblock_sub_result_show_text{
    position:absolute;
    top:30/50rem;
    right:0;
    width:119/50rem;
    height:35/50rem;
    line-height:35/50rem;
    font-size:22/50rem;
    color:#f99d9b;
    background:#ffe6e3;
    text-align:center;
    .border-radius-side(18/50rem,0,0,18/50rem);
  }
  .sunblock_sub_result_text{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-center;
    text-align:center;
    strong{
      font-size:28/50rem;
      line-height:1.1em;
      color:@font-c-3;
      text-align:center;
      border-bottom:1px solid #f99d9b;
      margin-bottom:10/50rem;
    }
  }
}
.sunblock_toaster{
  position:fixed;
  z-index:999;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background:rgba(0,0,0,0.3);
  .sunblock_toaster_inner{
    padding:0 30/50rem;
    background:#fff;
    .shadow;
    .border-radius(15/50rem);
    position:absolute;
    top:50%;
    left:50%;
    -webkit-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
    width:596/50rem;
    height:547/50rem;
    .sunblock_toaster_inner_title{
      padding-top:73/50rem;
      padding-bottom:20/50rem;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-start;
      strong{
        font-size:30/50rem;
        line-height:1.1em;
        color:@font-c-3;
        font-weight:bold;
        border-bottom:1px solid @font-c-3;
      }
    }
    .sunblock_toaster_inner_2nd_title{
      padding-top:28/50rem;
      font-size:28/50rem;
      line-height:42/50rem;
      color:#f99d9b;
    }
    .sunblock_toaster_inner_text{
      font-size:22/50rem;
      line-height:26/50rem;
      color:@font-c-6;
    }
    .sunblock_inner_close_btn{
      position:absolute;
      top:30/50rem;
      right:30/50rem;
      width:30/50rem;
      height:30/50rem;
    }
  }
}
.filter_sub_btn{
  .display_flex;
  .flex-wrap_nowrap;
  .justify-content_flex-end;
  span{
    font-size:24/50rem;
    color:@font-c-3;
    background:@font-c-detail;
  }
}
//问号解释
.sunblock_doubt_layer{
  position:fixed;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background:rgba(0,0,0,0.2);
  .sunblock_layer_card{
    box-sizing:border-box;
    width:596/50rem;
    padding:73/50rem 30/50rem 69/50rem;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    .border-radius(15/50rem);
    .shadow;
    background:@font-c-f;
    .sunblock_doubt_layer_title{
      font-size:30/50rem;
      line-height:1.1em;
      font-weight:bold;
      color:@font-c-3;
      border-bottom:1px solid @font-c-3;
    }
    .sunblock_doubt_text{
      padding-top:30/50rem;
      font-size:26/50rem;
      line-height:30/50rem;
      color:@font-c-6;
    }
    .sunblock_doubt_close{
      position:absolute;
      right:30/50rem;
      top:30/50rem;
      width:30/50rem;
      height:30/50rem;
    }
  }
}

.guide_inner{
    background:@bg_c_m;
    padding:0 0 169/50rem;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.inner_up{
    padding:106/50rem 30/50rem 0;
    background:@font-c-f;
    .shadow;
    .guide_title{
        position:relative;
        padding-bottom:86/50rem;
        font-size:44/50rem;
        font-weight:bold;
        line-height:1em;
        text-align:center;
        color:@font-c-3;
        span{
          position:absolute;
          bottom:86/50rem;
          right:90/50rem;
          display:inline-block;
          margin-left:20/50rem;
          font-size:24/50rem;
          line-height:1em;
          color:@font-c-detail;
          border-bottom:1px solid @font-c-detail;
        }
    }
    .detail_menu {
    position:relative;
    box-sizing: border-box;
    // .shadow;
    // padding: 81/50rem 30/50rem 0/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .menu_item {
      padding-bottom: 27/50rem;
      .align-items_flex-end;
      .flex_0;
      width: 33.33%;
      font-size: 28/50rem;
      line-height: 1em;
      text-align: center;
      color: @font-c-3;
      border-bottom: 3px solid transparent;
      &.now {
        font-size: 34/50rem;
        font-weight: bold;
        color:@font-c-detail;
        // border-bottom: 3px solid #f099a6;
      }
    }
  }
    .bg_div{
    position:absolute;
    bottom:0;
    height:3px;
    width:1/50rem;
    background:@font-c-detail;
    -webkit-transition:left 0.5s;
    transition:left 0.5s;
    }
}
.inner_down{
    padding:53/50rem 30/50rem 104/50rem;
}
.inner_down_first{
    .down_title{
        padding-bottom:27/50rem;
        font-size:34/50rem;
        font-weight:bold;
        line-height:1em;
        color:@font-c-3;
    }
    .down_item{
        box-sizing:border-box;
        padding:38/50rem 35/50rem 50/50rem;
        margin-bottom:63/50rem;
        .border-radius(14/50rem);
        .shadow;
        .gradient(to right,@sunblock-s-1,@sunblock-e-1);
        .item_sug{
            box-sizing:border-box;
            .border-radius(14/50rem);
            background:rgba(255,255,255,0.7);
            padding:21/50rem 30/50rem 15/50rem;
            .item_sug_title{
                font-size:28/50rem;
                font-weight:bold;
                line-height:1em;
                color:@font-c-3;
                text-align:center;
            }
            .item_sug_info{
                font-size:28/50rem;
                line-height:42/50rem;
                color:@font-c-3;
                strong{
                    border-bottom:5px dotted #ea5514;
                }
                img{
                    width:30/50rem;
                    height:30/50rem;
                }
                
            }
        }
    }
    .down_item_aging{
       .gradient(to right,@sunblock-s-2,@sunblock-e-2);
    }
    .down_item_pm{
       .gradient(to right,@sunblock-s-3,@sunblock-e-3);
    }
    .item_detail{
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-justify;
        padding-top:30/50rem;
        .item_detail_left,.item_detail_right,.item_detail_pic{
            .flex_0;
            .align-self_flex-start;
        }
        .detail_left_li{
          position:relative;
            margin-left:23/50rem;
            margin-bottom:18/50rem;
            // border-bottom:1px solid @font-c-f; 
            font-size:28/50rem;
            line-height:1em;
            color:@font-c-f;
            strong{
              border-bottom:1px solid @font-c-f;
            }
            &::before{
              content:"";
              display:block;
              position:absolute;
              top:50%;
              left:-23/50rem;
              transform:translateY(-50%) scale(0.5);
              width:10px;
              height:10px;
              .border-radius(50%);
              background:@font-c-f;
            }
        }
        .item_detail_pic{
          width:83/50rem;
          // height:114/50rem;
        }
        .item_detail_right{
          .detail_right_title{
            font-size:58/50rem;
            line-height:74/50rem;
            color:#fff0d5;
            text-shadow:0 2px 4px #ffb272;
          }
          .detail_right_tip{
            font-size:24/50rem;
            line-height:1em;
            color:#fff0d5;
            text-shadow:0 2px 4px #ffb272;
          }
        }

    }
    .down_item_aging .item_detail_pic{
      width:128/50rem;
    }
      
}
.inner_down_second{
  .down_title{
    padding-bottom:28/50rem;
    font-size:34/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-3;
  }
  .filter_menu{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    .menu_item{
      // .border-1px;
      .flex_0;
      .border-radius(25/50rem);
      box-sizing:border-box;
      border:1px solid @font-c-detail;
      padding:13/50rem 30/50rem;
      margin-right:20/50rem;
      font-size:28/50rem;
      line-height:1em;
      color:@font-c-detail;
      background:transparent;
      &.now{
        box-sizing:border-box;
        background:@font-c-detail;
        .border-radius(25/50rem);
        color:@font-c-f;
      }
    }

  }
  .filter_pro_list{
    padding:22/50rem 0 191/50rem;
    .filter_pro{
      position:relative;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-start;
      .filter_pro_pic,.filter_pro_info{
        .align-self_center;
      }
      .filter_pro_pic{
        width:163/50rem;
      }
      .filter_pro_info{
        width:514/50rem;
        box-sizing:border-box;
        padding:45/50rem 0 45/50rem 12/50rem;
        // border-bottom:1px solid @font-c-detail;
        .border-bottom;
        .pro_name{
          font-size:30/50rem;
          line-height:1em;
          color:@font-c-3;
        }
        .pro_price{
          padding:13/50rem 0 0rem;
          font-size:24/59rem;
          line-height:1em;
          color:@font-c-9;
        }
        .pro_spf{
          padding:13/50rem 0 26/50rem;
          font-size:24/59rem;
          line-height:1em;
          color:@font-c-9;
        }
        .pro_tags{
          .display_flex;
          .flex-wrap_wrap;
          .justify-content_flex-start;
          .tag{
            box-sizing:border-box;
            padding:8/50rem 25/50rem;
            margin-right:20/50rem;
            .border-radius(23/50rem);
            background:#ffe6e3;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-detail;
          }
        }
      }
      &.now::after{
        content:"推荐";
        display:block;
        width:74/50rem;
        height:74/50rem;
        .border-radius(50%);
        text-align:center;
        background:#ffe6e3;
        color:@font-c-detail;
        font-size:24/50rem;
        line-height:74/50rem;
        position:absolute;
        bottom:45/50rem;
        right:38/50rem;
      }
    }
  }

}

.inner_down_third{
    .down_title{
    padding-bottom:28/50rem;
    font-size:34/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-3;
  }
  .sun_block_sug_2nd_title{
    padding-bottom:50/50rem;
    font-size:34/50rem;
    font-weight:bold;
    line-height:1em;
    color:@font-c-3;
  }
    .sun_block_sug_2nd_text{
    padding-bottom:50/50rem;
    font-size:28/50rem;
    line-height:34/50rem;
    color:@font-c-3;
  }
  .sun_block_2nd_example_pic{
    display:block;
    margin:0 auto 60/50rem;
    .shadow;
    .border-radius(14/50rem);
    width:514/50rem;
    height:314/50rem;
  }
  .sun_block_sug_list{
    // width:564/50rem;
    margin:0 auto 56/50rem;
    padding:14/50rem 30/50rem 26/50rem;
    box-sizing:border-box;
    .border-radius(14/50rem);
    .shadow;
    .sun_block_sug_info{
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-start;
      .border-bottom;
      padding:28/50rem 0 23/50rem;
      &:last-child{
        .border-bottom-transparent;
      }
      span{
        box-sizing:border-box;
        .flex_0;
        font-size:28/50rem;
        line-height:1em;
        color:@font-c-3;
        &:first-child{
          width:190/50rem;
        }
        &:last-child{
          width:436/50rem;
        }
      }
    }
  }
  .sun_block_sug_list_2{
    .sun_block_sug_info{
      span{
        box-sizing:border-box;
        .flex_0;
        font-size:28/50rem;
        line-height:1em;
        color:@font-c-3;
        padding-right:50/50rem;
        &:first-child{
          width:330/50rem;
        }
        &:last-child{
          width:330/50rem;
        }
      }
    }

  }
  .sun_block_sug_2nd_title_name{
    position:relative;
    padding-left:24/50rem;
    font-size:26/50rem;
    line-height:1em;
    color:@font-c-3;
    &::before{
      content:"";
      display:block;
      position:absolute;
      top:50%;
      left:0;
      transform:translateY(-50%) scale(0.5);
      width:10px;
      height:10px;
      .border-radius(50%);
      background:@font-c-0;
    }
  }
  .sun_block_sug_2nd_title_desc{
    padding:11/50rem 0 29/50rem;
    font-size:26/50rem;
    line-height:28/50rem;
    color:@font-c-9;
  }
}


</style>
